import api from "@/lib/axios";

export const reportService = {
  async getStats(exclude = false) {
    const response = await api.get('/v1/dashboardStats', {
      params: { exclude }
    });
    return response.data;
  },
  
  async getUserSessions(page = 1, searchParams = {}, exclude = false) {
    // Build query string with searchParams
    let queryString = `page=${page}`;
    
    // Add name search param if provided
    if (searchParams.name) {
      queryString += `&name=${encodeURIComponent(searchParams.name)}`;
    }
    
    // Add email search param if provided
    if (searchParams.email) {
      queryString += `&email=${encodeURIComponent(searchParams.email)}`;
    }
    
    // Add exclude param
    queryString += `&exclude=${exclude}`;
    
    const response = await api.get(`/v1/userssessionlength?${queryString}`);
    return response.data;
  },

  // Method to download reports in CSV format
  async downloadReports(searchParams = {}, exclude = false) {
    try {
      // Merge exclude into searchParams
      const params = { ...searchParams, exclude };
      // TODO: Replace with actual API endpoint when available
      const response = await api.get('/download', {
        params,
        responseType: 'blob'  // Important for file download
      });
      
      // Create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `postscrypt_reports_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return true;
    } catch (error) {
      console.error('Error downloading reports:', error);
      throw error;
    }
  }
}; 